import { SideImage } from '../../components/SideImage';
import { StickyFooter } from '../../components/StickyFooter';
import { SpaTreatmentFacilityBookingContent } from '../../composites/SpaTreatmentFacilityBookingContent';
import { SplitLayout } from '../../composites/SplitLayout';
import { HideOnMobile } from './SpaTreatmentFacilityBookingForm.styles';
import type { SpaTreatmentFacilityBookingFormProps } from './SpaTreatmentFacilityBookingForm.types';

export function SpaTreatmentFacilityBookingForm({
  imageUrl,
  imageAlt,
  onBack,
  stickyFooter,
  labels,
  ...contentProps
}: SpaTreatmentFacilityBookingFormProps) {
  const {
    title,
    subtitle,
    noteText,
    calendar,
    stickyFooter: stickyFooterLabels,
    ...contentLabels
  } = labels;

  return (
    <SplitLayout
      left={
        <HideOnMobile>
          <SideImage src={imageUrl} alt={imageAlt} sticky onBack={onBack} />
        </HideOnMobile>
      }
      right={
        <>
          <SpaTreatmentFacilityBookingContent
            {...contentProps}
            title={title}
            subtitle={subtitle}
            noteText={noteText}
            calendarLabels={calendar}
            labels={contentLabels}
          />
          {stickyFooter && stickyFooterLabels && (
            <StickyFooter
              {...stickyFooter}
              totalLabel={stickyFooterLabels.totalLabel}
              ctaLabel={stickyFooterLabels.ctaLabel}
            />
          )}
        </>
      }
      contentGap="0px"
      contentMaxWidth="100%"
    />
  );
}
